var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxedLights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.1 71.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      @keyframes blink-red {\n        0%, 25%, 75%, 100% { fill: #ff6d6d; }\n        50% { fill: #520b0b; }\n      }\n\n      @keyframes blink-green {\n        0%, 50%, 75%, 100% { fill: #1eff5f; }\n        25% { fill: #094f1d; }\n      }\n\n      @keyframes blink-blue {\n        0%, 25%, 50%, 75%, 100% { fill: #6dfcff; }\n        75% { fill: #074243; }\n      }\n\n      .red-light {\n        animation: blink-red 1s step-end infinite;\n        fill: #520b0b;\n      }\n\n      .green-light {\n        animation: blink-green 1s step-end infinite;\n        fill: #094f1d;\n      }\n\n      .blue-light {\n        animation: blink-blue 1s step-end infinite;\n        fill: #074243;\n      }\n\n      .bl-cls-1 {\n        fill: none;\n        stroke: #010101;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bl-cls-1",
    d: "M276.35,57.96c-17.66,31.2-33.97-34.6-38.57-57.21-24.13,29.89-47.49,27.21-72,0-11.43,4.66-21.51,4.79-33.32,0-16.82,17.69-51.1,18.45-66.99,0C44.6,14.22,18.37,13.01.75.75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 263.64,
    cy: 67.96,
    rx: 3.96,
    ry: 2.47,
    transform: "translate(135.84 308.36) rotate(-76.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 89.91,
    cy: 16.4,
    rx: 3.96,
    ry: 2.47,
    transform: "translate(55.59 101.11) rotate(-78.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 211.23,
    cy: 23.75,
    rx: 2.47,
    ry: 3.96,
    transform: "translate(-.45 43.07) rotate(-11.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 154.59,
    cy: 6.65,
    rx: 2.47,
    ry: 3.96,
    transform: "translate(.74 23.13) rotate(-8.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 18.9,
    cy: 12.24,
    rx: 3.96,
    ry: 2.47,
    transform: "translate(2.02 27.15) rotate(-74.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 123.74,
    cy: 10.52,
    rx: 2.47,
    ry: 3.96,
    transform: "translate(.33 24.36) rotate(-11.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 242.38,
    cy: 26.27,
    rx: 3.96,
    ry: 2.47,
    transform: "translate(127.92 241.53) rotate(-68.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 36.5,
    cy: 13.26,
    rx: 2.47,
    ry: 3.96,
    transform: "translate(-1.57 5.59) rotate(-8.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 185.44,
    cy: 20.31,
    rx: 3.96,
    ry: 2.47,
    transform: "translate(127.88 197.76) rotate(-78.28)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxedLights);
export default __webpack_public_path__ + "static/media/boxed-lights.ad005834ae2827ee8cee6f9e84e42c8d.svg";
export { ForwardRef as ReactComponent };